let storeInstance: any = null;

export const setStoreRef = (store: any) => {
  storeInstance = store;
};

export const getStoreRef = () => storeInstance;
